import api from '../../utils/api'

export const certificacaoService = {
  async getInfoAnaliseCertificacao (idProcesso) {
    return api({
      url: `processo/infoAnaliseCertificacao/${idProcesso}`,
      method: 'GET'
    })
  },

  async salvarCertificacao (dados, despacho) {
    if (despacho.dataCadastro && Array.isArray(despacho.dataCadastro)) {
      const [ano, mes, dia, hora, min, seg, nano] = despacho.dataCadastro
      const data = new Date(ano, mes - 1, dia, hora, min, seg, nano / 1000000)
      despacho.dataCadastro = data.toISOString()
    }
    const { texto, ...dadosSemTexto } = dados.certificado
    const payload = {
      despacho: despacho,
      certificado: {
        ...dadosSemTexto,
        texto: texto || ''
      }
    }
    return api({
      url: 'certificado/salvar',
      method: 'PUT',
      data: payload
    })
  },

  async finalizarCertificacao (dados, despacho, acao) {
    if (despacho.dataCadastro && Array.isArray(despacho.dataCadastro)) {
      const [ano, mes, dia, hora, min, seg, nano] = despacho.dataCadastro
      const data = new Date(ano, mes - 1, dia, hora, min, seg, nano / 1000000)
      despacho.dataCadastro = data.toISOString()
    }
    const { texto, ...dadosSemTexto } = dados.certificado
    const payload = {
      despacho: despacho,
      certificado: {
        ...dadosSemTexto,
        texto: texto || ''
      },
      acao: acao
    }
    return api({
      url: 'certificado/finalizar',
      method: 'POST',
      data: payload
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/certificacao/index.js